// Polyfills for IE < 11
import 'core-js/es5';
import 'core-js/es6/array';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/string';
import 'core-js/es6/number';
import 'raf/polyfill';
import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/fi';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import { useStrict } from 'mobx';
import { Provider } from 'mobx-react';
import { Route, Switch } from 'react-router';
import { HashRouter as Router } from 'react-router-dom';
import { unregister } from './registerServiceWorker';

import AuthStore from './stores/AuthStore';
import ProductStore from './stores/ProductStore';
import CartStore from './stores/CartStore';
import CustomerStore from './stores/CustomerStore';
import OrderFormStore from './stores/OrderFormStore';
import NotificationStore from './stores/NotificationStore';
import OrderTypesStore from './stores/OrderTypesStore';
import CompanyStore from './stores/CompanyStore';
import FeedbackStore from './stores/FeedbackStore';
import ModalStore from './stores/ModalStore';
import OrderHistoryStore from './stores/OrderHistoryStore';
import FilterStore from './stores/FilterStore';

import App from './App';
import './index.css';

import {
  PRODUCT_STORE,
  CART_STORE,
  CUSTOMER_STORE,
  ORDER_FORM_STORE,
  NOTIFICATION_STORE,
  AUTH_STORE,
  ORDER_TYPES_STORE,
  COMPANY_STORE,
  FEEDBACK_STORE,
  MODAL_STORE,
  ORDER_HISTORY_STORE,
  FILTER_STORE
} from './constants/constants';

const history = createBrowserHistory();
const notificationStore = new NotificationStore([]);
const companyStore = new CompanyStore();

const productStore = new ProductStore(
  [],
  notificationStore,
  companyStore
);

const cartStore = new CartStore({ products: [] });
const customerStore = new CustomerStore([], notificationStore, companyStore);
const orderFormStore = new OrderFormStore(notificationStore, companyStore);
const authStore = new AuthStore(companyStore);
const orderTypesStore = new OrderTypesStore([], notificationStore, companyStore);
const feedbackStore = new FeedbackStore(notificationStore, companyStore);
const modalStore = new ModalStore();
const orderHistoryStore = new OrderHistoryStore([], companyStore, notificationStore);
const filterStore = new FilterStore(companyStore, notificationStore);

const rootStores = {
  [PRODUCT_STORE]: productStore,
  [CART_STORE]: cartStore,
  [CUSTOMER_STORE]: customerStore,
  [ORDER_FORM_STORE]: orderFormStore,
  [NOTIFICATION_STORE]: notificationStore,
  [AUTH_STORE]: authStore,
  [ORDER_TYPES_STORE]: orderTypesStore,
  [COMPANY_STORE]: companyStore,
  [FEEDBACK_STORE]: feedbackStore,
  [MODAL_STORE]: modalStore,
  [ORDER_HISTORY_STORE]: orderHistoryStore,
  [FILTER_STORE]: filterStore
};

ReactDOM.render(
  <Provider {...rootStores}>
    <Router >
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root') as HTMLElement
);

unregister();


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx